import { useCallback, useContext, useEffect, useState } from "react";
import "./DepotManagement.css";
import Loader from "../../components/Loader";
import { Link, useNavigate } from "react-router-dom";
import { Grid2 } from "@mui/material";
import StyledGridComp from "../../components/StyledGridComp";
import { formatDate, notifyError } from "../../utilities/helper";
import { fetchAllDepotManagementService } from "../../services/depotManagementService";
import { MenuContext } from "../../App";
import SearchedComponent from "../../components/SearchedComponent";
import useDebounceSearch from "../../hooks/useDebounceSearch";
import { Home } from "@mui/icons-material";

const DepotManagement = () => {
  const [load, setLoad] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [rowData, setRowData] = useState([]);
  const [rowLength, setRowLength] = useState(0);
  const [canCreateDepot, setCanCreateDepot] = useState(false);
  const [searchedValue, setSearchedValue] = useState("");
  const navigate = useNavigate();

  const debounceQuery = useDebounceSearch(searchedValue, 500);

  const access_token = localStorage?.getItem("access_token");

  const role = localStorage.getItem("role");
  const { systemActions } = useContext(MenuContext);

  useEffect(() => {
    if (page >= 0 && pageSize && access_token) {
      getAllDepotManagement(pageSize, page, access_token, debounceQuery);
    }
  }, [page, pageSize, access_token, debounceQuery]);

  useEffect(() => {
    if (systemActions?.length > 0 && role !== "Admin") {
      const found = systemActions?.find(
        (item) => item?.name === "CanCreateDepotList",
      );
      if (found) {
        setCanCreateDepot(true);
      } else {
        setCanCreateDepot(false);
      }
    } else if (role === "Admin") {
      setCanCreateDepot(true);
    }
  }, [systemActions, role]);

  const getAllDepotManagement = async (
    pageSize,
    page,
    access_token,
    debouncedSearch = "",
  ) => {
    setLoad(true);
    try {
      const res = await fetchAllDepotManagementService(
        page + 1,
        pageSize,
        access_token,
        debouncedSearch,
      );
      if (res?.status == 200) {
        setLoad(false);
        setRowData(res?.data?.result);
        setRowLength(res?.data?.totalCount);
      }
    } catch (err) {
      setLoad(false);
      notifyError(err?.mesage);
      console.log(err);
      if (err?.status == 401) {
        navigate("/unauthorize");
      }
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Depot Name",
      width: 300,
      renderHeader: () => <div className="grid-heading">{"Depot Name"}</div>,
      renderCell: (params) => {
        const name = params.row.name;
        const id = params.row.id;

        return (
          <button
            className="bread-crumbs-link grid-nav-btn"
            onClick={() => {
              navigate("/addUpdate-depot-management", {
                state: {
                  id: id,
                },
              });
            }}
          >
            {name}
          </button>
        );
      },
    },
    {
      field: "countryName",
      headerName: "Country",
      width: 300,
      renderHeader: () => <div className="grid-heading">{"Country"}</div>,
      renderCell: (params) => {
        const countryName = params.row.countryName;

        return <span className="data-font">{countryName}</span>;
      },
    },
    {
      field: "active",
      headerName: "Active",
      width: 250,
      renderHeader: () => <div className="grid-heading">{"Active"}</div>,
      renderCell: (params) => {
        const active = params.row.active;

        return <span className="data-font">{!active ? "False" : "True"}</span>;
      },
    },
    {
      field: "lastUpdate",
      headerName: "Last Updated",
      width: 300,
      renderHeader: () => <div className="grid-heading">{"Last Updated"}</div>,
      renderCell: (params) => {
        const lastUpdate = params.row.lastUpdate;
        return (
          <span className="data-font">
            {lastUpdate ? formatDate(lastUpdate) : null}
          </span>
        );
      },
    },
  ];

  const handleSearch = useCallback((e) => {
    setSearchedValue(e.target.value);
  }, []);

  return (
    <div className="content-body">
      <div className="home-container">
        <p
          className="bread-crumbs-link-container"
          style={{ fontWeight: "600" }}
        >
          <Link className="bread-crumbs-link" to="/">
            Home
          </Link>{" "}
          |{" "}
          <Link className="bread-crumbs-link" to="/depot-management">
            Depot Management
          </Link>
          -{" "}
          <b style={{ color: "gray" }}>{localStorage?.getItem("studyName")}</b>
        </p>
        <Link className="bread-crumbs-link home-inner-container">
          Set as Home Page
          <span>
            <Home
              sx={{
                fontSize: "20px",
              }}
            />
          </span>
        </Link>
      </div>
      <Grid2
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: "100%", margin: "0 auto" }}
      >
        <Grid2 item md={4}>
          <p className="page-heading">Depot Management</p>
        </Grid2>
        <Grid2 item md={8}>
          <div className="search-bar-container">
            <SearchedComponent
              searchedValue={searchedValue}
              handleSearch={handleSearch}
              placeholder={"Depot"}
            />
            {canCreateDepot ? (
              <button
                className="create-btn"
                onClick={() => navigate("/addUpdate-depot-management")}
              >
                Add New Depot
              </button>
            ) : null}
          </div>
        </Grid2>
      </Grid2>

      {load ? (
        <Loader />
      ) : (
        <StyledGridComp
          rows={rowData}
          columns={columns}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          length={rowLength}
        ></StyledGridComp>
      )}
      <Grid2
        alignItems={"end"}
        justifyContent="end"
        container
        sx={{ marginTop: "2%" }}
      >
        <Grid2 item md={6}>
          <button className="create-btn">Back</button>
        </Grid2>
      </Grid2>
    </div>
  );
};

export default DepotManagement;
